import { jsxs as l, Fragment as r, jsx as C } from "react/jsx-runtime";
const o = () => /* @__PURE__ */ l(r, { children: [
  /* @__PURE__ */ C(
    "path",
    {
      d: "M6 1C4.34315 1 3 2.34315 3 4V21C3 22.1046 3.89543 23 5 23H18C19.6569 23 21 21.6569 21 20V9.5H16.5C14.2909 9.5 12.5 7.70914 12.5 5.5V1H6ZM13 11C13 10.4477 12.5523 10 12 10C11.4477 10 11 10.4477 11 11V16.5858L9.70711 15.2929C9.31658 14.9024 8.68342 14.9024 8.29289 15.2929C7.90237 15.6834 7.90237 16.3166 8.29289 16.7071L11.2929 19.7071C11.6834 20.0976 12.3166 20.0976 12.7071 19.7071L15.7071 16.7071C16.0976 16.3166 16.0976 15.6834 15.7071 15.2929C15.3166 14.9024 14.6834 14.9024 14.2929 15.2929L13 16.5858V11Z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ),
  /* @__PURE__ */ C("path", { d: "M16.5 7.5C15.3954 7.5 14.5 6.60457 14.5 5.5V1.01758C17.9675 1.2623 20.7377 4.03251 20.9824 7.5H16.5Z", fill: "currentColor" })
] });
export {
  o as default
};
